import React from "react";
import { Dialog } from "@mui/material";
import { useFormikContext } from "formik";
import AddNewTag from "pages/Members/MemberDetails/AddNewTag";
// direct import
import { LabelField } from "../LabelField";
import "./style.scss";
import { fontConfig } from "theme/fontConfig";

const TagManager = ({
  name = "",
  open,
  setOpen,
  label = "Add Tags",
  tagType = "account",
}) => {
  const { values, setFieldValue } = useFormikContext();

  const tags =
    name?.split(".").reduce((acc, part) => acc?.[part], values) || [];

  const handleAddTag = (tag) => {
    const tagExists = tags.some(
      (existing) => existing.toLowerCase() === tag.toLowerCase()
    );

    if (tagExists) {
      // Optional: display UI warning instead of alert
      alert("Duplicate tag. Please enter a unique tag.");
      return;
    }

    const updated = [...tags, tag];
    setFieldValue(name, updated);
  };

  const handleDeleteTag = (tag) => {
    const updated = tags.filter(
      (existing) => existing.toLowerCase() !== tag.toLowerCase()
    );
    setFieldValue(name, updated);
  };

  return (
    <div className="event_tags-container">
      <div className="d-flex" style={{ gap: "5px" }}>
        <LabelField
          mandatory={false}
          style={{
            fontFamily: fontConfig.GeneralLabelFieldFont.family,
            fontWeight: "400",
            fontSize: "12px",
            lineHeight: "18px",
            color: "#4F4F4F",
          }}
        >
          {label}
        </LabelField>
      </div>

      <div className="event_tags">
        {tags?.length > 0 &&
          tags
            ?.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
            .map((tag) => (
              <span className="event_tag" key={tag}>
                {tag}
                <span
                  style={{
                    marginLeft: "5px",
                    fontSize: "12px",
                    fontWeight: "400",
                    cursor: "pointer",
                  }}
                  onClick={() => handleDeleteTag(tag)}
                >
                  x
                </span>
              </span>
            ))}

        <div className="event_add-tag">
          <span
            style={{
              color: "#B5B5C3",
              fontFamily: fontConfig.AddTagsTextFont.family,
              fontWeight: "500",
              fontSize: "13px",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => setOpen(true)}
          >
            <strong>+</strong> Add a tag
          </span>
        </div>
      </div>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          style: {
            border: "1px solid #000000",
            background: "#f5f5f5",
          },
        }}
      >
        <AddNewTag
          setOpenTag={setOpen}
          openTag={open}
          addTagHandler={handleAddTag}
          deleteTagHandler={handleDeleteTag}
          selectedUserTag={tags}
          type={tagType}
        />
      </Dialog>
    </div>
  );
};

export default TagManager;
